<ox-family-sharing-alert 
    *ngIf="userName && userRole && userRole !== 'OWNER'" 
    class="mb-3" 
    [user]="userName">
</ox-family-sharing-alert>
<ox-account-alert
    *ngIf="paymentMethod && paymentMethod.expiryStatus"
    (handleButton)="handlePaymentMethod(paymentMethod.expiryStatus.buttonText)"
    [linkOrButtonText]="paymentMethod.expiryStatus.buttonText" 
    [message]="paymentMethod.expiryStatus.message" 
    [type]="'error'"
    class="mb-3">
</ox-account-alert>
<ng-container *ngIf="alerts" >
    <ox-account-alert
        *ngFor="let alert of alerts"
        (handleButton)="handleUrl(alert.button.displayText,alert.button.url)" 
        [linkOrButtonText]="alert.button.displayText" 
        [message]="alert.copy.content" 
        [type]="'error'"
        class="mb-3">
    </ox-account-alert>
</ng-container>
